import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { onAddToTribe, onFetchGhostPosts, onSendEmail } from '../../util/api';
import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { createImageVariantConfig, types as sdkTypes, util as sdkUtil } from '../../util/sdkLoader';
import { PROFILE_PAGE_PENDING_APPROVAL_VARIANT } from '../../util/urlHelpers';
import { hasPermissionToViewData, isUserAuthorized } from '../../util/userHelpers';

const { UUID } = sdkTypes;

const getSlugFromUrl = urlString => {
  try {
    const url = new URL(urlString);
    const pathname = url.pathname;

    const parts = pathname.split('/').filter(part => part !== '');

    const slug = parts[parts.length - 1];
    return slug;
  } catch (error) {
    console.error('Invalid URL:', error);
  }
};

// ================ Action types ================ //

export const SET_INITIAL_STATE = 'app/ProfilePage/SET_INITIAL_STATE';

export const SHOW_USER_REQUEST = 'app/ProfilePage/SHOW_USER_REQUEST';
export const SHOW_USER_SUCCESS = 'app/ProfilePage/SHOW_USER_SUCCESS';
export const SHOW_USER_ERROR = 'app/ProfilePage/SHOW_USER_ERROR';

export const QUERY_LISTINGS_REQUEST = 'app/ProfilePage/QUERY_LISTINGS_REQUEST';
export const QUERY_LISTINGS_SUCCESS = 'app/ProfilePage/QUERY_LISTINGS_SUCCESS';
export const QUERY_LISTINGS_ERROR = 'app/ProfilePage/QUERY_LISTINGS_ERROR';

export const QUERY_REVIEWS_REQUEST = 'app/ProfilePage/QUERY_REVIEWS_REQUEST';
export const QUERY_REVIEWS_SUCCESS = 'app/ProfilePage/QUERY_REVIEWS_SUCCESS';
export const QUERY_REVIEWS_ERROR = 'app/ProfilePage/QUERY_REVIEWS_ERROR';

export const TRIBE_USERS_LISTING_REQUEST = 'app/ProfilePage/TRIBE_USERS_LISTING_REQUEST';
export const TRIBE_USERS_LISTING_SUCCESS = 'app/ProfilePage/TRIBE_USERS_LISTING_SUCCESS';
export const TRIBE_USERS_LISTING_ERROR = 'app/ProfilePage/TRIBE_USERS_LISTING_ERROR';

export const SHOW_ENDORSED_USERS_REQUEST = 'app/ProfilePage/SHOW_ENDORSED_USERS_REQUEST';
export const SHOW_ENDORSED_USERS_SUCCESS = 'app/ProfilePage/SHOW_ENDORSED_USERS_SUCCESS';
export const SHOW_ENDORSED_USERS_ERROR = 'app/ProfilePage/SHOW_ENDORSED_USERS_ERROR';

export const ADD_USERS_TO_TRIBE_REQUEST = 'app/ProfilePage/ADD_USERS_TO_TRIBE_REQUEST';
export const ADD_USERS_TO_TRIBE_SUCCESS = 'app/ProfilePage/ADD_USERS_TO_TRIBE_SUCCESS';
export const ADD_USERS_TO_TRIBE_ERROR = 'app/ProfilePage/ADD_USERS_TO_TRIBE_ERROR';

export const FETCH_GHOST_POSTS_REQUEST = 'app/ProfilePage/FETCH_GHOST_POSTS_REQUEST';
export const FETCH_GHOST_POSTS_SUCCESS = 'app/ProfilePage/FETCH_GHOST_POSTS_SUCCESS';
export const FETCH_GHOST_POSTS_ERROR = 'app/ProfilePage/FETCH_GHOST_POSTS_ERROR';

export const SEARCH_SUGGESTIONS_REQUEST = 'app/ProfilePage/SEARCH_SUGGESTIONS_REQUEST';
export const SEARCH_SUGGESTIONS_SUCCESS = 'app/ProfilePage/SEARCH_SUGGESTIONS_SUCCESS';
export const SEARCH_SUGGESTIONS_ERROR = 'app/ProfilePage/SEARCH_SUGGESTIONS_ERROR';

export const SEND_EMAIL_REQUEST = 'app/ProfilePage/SEND_EMAIL_REQUEST';
export const SEND_EMAIL_SUCCESS = 'app/ProfilePage/SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_ERROR = 'app/ProfilePage/SEND_EMAIL_ERROR';

// ================ Reducer ================ //

const initialState = {
  userId: null,
  userListingRefs: [],
  userShowError: null,
  queryListingsError: null,
  reviews: [],
  queryReviewsError: null,

  listinsgPending: true,
  listings: [],
  listingsError: null,

  endorsedUsersPending: false,
  endorsedUsers: [],
  endorsedUsersError: null,

  postsPending: false,
  posts: {
    data: [],
    meta: {},
  },
  postsError: null,

  suggestionsPending: false,
  suggestions: [],
  suggestionsError: null,

  sendEmailInProgress: false,
  sendEmailSuccessMsg: null,
  sendEmailErrorMsg: null,

  endorseRequestInprogress: false,
};

export default function profilePageReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SET_INITIAL_STATE:
      return { ...initialState };
    case SHOW_USER_REQUEST:
      return { ...state, userShowError: null, userId: payload.userId };
    case SHOW_USER_SUCCESS:
      return state;
    case SHOW_USER_ERROR:
      return { ...state, userShowError: payload };

    case QUERY_LISTINGS_REQUEST:
      return {
        ...state,
        userListingRefs: payload.userId === state.userId ? state.userListingRefs : [],
        queryListingsError: null,
      };
    case QUERY_LISTINGS_SUCCESS:
      return { ...state, userListingRefs: payload.listingRefs };
    case QUERY_LISTINGS_ERROR:
      return { ...state, userListingRefs: [], queryListingsError: payload };
    case QUERY_REVIEWS_REQUEST:
      return { ...state, queryReviewsError: null };
    case QUERY_REVIEWS_SUCCESS:
      return { ...state, reviews: payload };
    case QUERY_REVIEWS_ERROR:
      return { ...state, reviews: [], queryReviewsError: payload };

    case TRIBE_USERS_LISTING_REQUEST:
      return {
        ...state,
        listinsgPending: true,
      };
    case TRIBE_USERS_LISTING_SUCCESS:
      return {
        ...state,
        listinsgPending: false,
        listings: payload,
      };
    case TRIBE_USERS_LISTING_ERROR:
      return {
        ...state,
        listings: [],
        listingsError: payload,
      };

    case SHOW_ENDORSED_USERS_REQUEST:
      return {
        ...state,
        endorsedUsersPending: true,
      };
    case SHOW_ENDORSED_USERS_SUCCESS:
      return {
        ...state,
        endorsedUsersPending: false,
        endorsedUsers: payload,
      };
    case SHOW_ENDORSED_USERS_ERROR:
      return {
        ...state,
        endorsedUsersError: payload,
      };

    case ADD_USERS_TO_TRIBE_REQUEST:
      return {
        ...state,
        endorseRequestInprogress: payload,
      };
    case ADD_USERS_TO_TRIBE_SUCCESS:
      return {
        ...state,
        endorseRequestInprogress: false,
      };
    case ADD_USERS_TO_TRIBE_ERROR:
      return {
        ...state,
        endorseRequestInprogress: false,
      };

    case FETCH_GHOST_POSTS_REQUEST:
      return {
        ...state,
        postsPending: true,
      };
    case FETCH_GHOST_POSTS_SUCCESS:
      return {
        ...state,
        postsPending: false,
        posts: payload,
      };
    case FETCH_GHOST_POSTS_ERROR:
      return {
        ...state,
        posts: {
          data: [],
          meta: {},
        },
        postsError: payload,
      };

    case SEARCH_SUGGESTIONS_REQUEST:
      return {
        ...state,
        suggestionsPending: true,
      };
    case SEARCH_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        suggestionsPending: false,
        suggestions: payload,
      };

    case SEARCH_SUGGESTIONS_ERROR:
      return {
        ...state,
        suggestions: [],
        suggestionsError: payload,
      };

    case SEND_EMAIL_REQUEST:
      return {
        ...state,
        sendEmailInProgress: true,
        sendEmailSuccessMsg: null,
        sendEmailErrorMsg: null,
      };
    case SEND_EMAIL_SUCCESS:
      return {
        ...state,
        sendEmailInProgress: false,
        sendEmailSuccessMsg: payload,
        sendEmailErrorMsg: null,
      };
    case SEND_EMAIL_ERROR:
      return {
        ...state,
        sendEmailInProgress: false,
        sendEmailSuccessMsg: null,
        sendEmailErrorMsg: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setInitialState = () => ({
  type: SET_INITIAL_STATE,
});

export const showUserRequest = userId => ({
  type: SHOW_USER_REQUEST,
  payload: { userId },
});

export const showUserSuccess = () => ({
  type: SHOW_USER_SUCCESS,
});

export const showUserError = e => ({
  type: SHOW_USER_ERROR,
  error: true,
  payload: e,
});

export const queryListingsRequest = userId => ({
  type: QUERY_LISTINGS_REQUEST,
  payload: { userId },
});

export const queryListingsSuccess = listingRefs => ({
  type: QUERY_LISTINGS_SUCCESS,
  payload: { listingRefs },
});

export const queryListingsError = e => ({
  type: QUERY_LISTINGS_ERROR,
  error: true,
  payload: e,
});

export const queryReviewsRequest = () => ({
  type: QUERY_REVIEWS_REQUEST,
});

export const queryReviewsSuccess = reviews => ({
  type: QUERY_REVIEWS_SUCCESS,
  payload: reviews,
});

export const queryReviewsError = e => ({
  type: QUERY_REVIEWS_ERROR,
  error: true,
  payload: e,
});

export const queryTribeUserListingsRequest = () => ({
  type: TRIBE_USERS_LISTING_REQUEST,
});

export const queryTribeUserListingsSuccess = payload => ({
  type: TRIBE_USERS_LISTING_SUCCESS,
  payload,
});

export const queryTribeUserListingsError = payload => ({
  type: TRIBE_USERS_LISTING_ERROR,
  payload,
});

export const showEndorsedUsersRequest = () => ({
  type: SHOW_ENDORSED_USERS_REQUEST,
});

export const showEndorsedUsersSuccess = payload => ({
  type: SHOW_ENDORSED_USERS_SUCCESS,
  payload,
});

export const showEndorsedUsersError = payload => ({
  type: SHOW_ENDORSED_USERS_ERROR,
  payload,
});

export const addUsersToTribeRequest = userId => ({
  type: ADD_USERS_TO_TRIBE_REQUEST,
  payload: userId,
});

export const addUsersToTribeSuccess = () => ({
  type: ADD_USERS_TO_TRIBE_SUCCESS,
});

export const addUsersToTribeError = () => ({
  type: ADD_USERS_TO_TRIBE_ERROR,
});

export const queryFetchGhostPostRequest = () => ({
  type: FETCH_GHOST_POSTS_REQUEST,
});

export const queryFetchGhostPostSuccess = payload => ({
  type: FETCH_GHOST_POSTS_SUCCESS,
  payload,
});

export const queryFetchGhostPostError = payload => ({
  type: FETCH_GHOST_POSTS_ERROR,
  payload,
});

export const querySuggestionsRequest = () => ({
  type: SEARCH_SUGGESTIONS_REQUEST,
});

export const querySuggestionsSuccess = payload => ({
  type: SEARCH_SUGGESTIONS_SUCCESS,
  payload,
});

export const querySuggestionsFailed = payload => ({
  type: SEARCH_SUGGESTIONS_ERROR,
  payload,
});

export const querySendEmailPending = () => ({
  type: SEND_EMAIL_REQUEST,
});
export const querySendEmailSuccess = payload => ({
  type: SEND_EMAIL_SUCCESS,
  payload,
});
export const querySendEmailError = payload => ({
  type: SEND_EMAIL_ERROR,
  payload,
});

// ================ Thunks ================ //

export const searchProfileListingSuggestions = (keyword, config) => {
  return async (dispatch, getState, sdk) => {
    const {
      aspectWidth = 1,
      aspectHeight = 1,
      variantPrefix = 'listing-card',
    } = config.layout.listingImage;
    const aspectRatio = aspectHeight / aspectWidth;

    dispatch(querySuggestionsRequest());

    if (keyword) {
      try {
        const resp = await sdk.listings.query({
          keywords: keyword,
          page: 1,
          pub_listingType: ['profileListing'],
          include: ['author', 'author.profileImage', 'images'],
          'fields.user': [
            'profile.displayName',
            'profile.abbreviatedName',
            'profile.firstName',
            'profile.lastName',
            'author.profileImage',
            'profile.publicData',
          ],
          'fields.image': [
            'variants.square-small',
            'variants.square-small2x',
            'variants.scaled-small',
            'variants.scaled-medium',
            `variants.${variantPrefix}`,
            `variants.${variantPrefix}-2x`,
          ],
          ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
          ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
          'limit.images': 1,
        });

        const listingFields = config?.listing?.listingFields;
        const sanitizeConfig = { listingFields };
        dispatch(addMarketplaceEntities(resp, sanitizeConfig));
        const entities = denormalisedResponseEntities(resp);
        dispatch(querySuggestionsSuccess(entities));
      } catch (error) {
        dispatch(querySuggestionsFailed(error.message));
        console.error('Error fetching profile listing suggestions:', error);
      }
    } else {
      dispatch(querySuggestionsSuccess([]));
    }
  };
};

export const getPosts = (authorSlug, slugs, page = 1) => async dispatch => {
  dispatch(queryFetchGhostPostRequest());

  try {
    const resp = await onFetchGhostPosts({
      authorSlug,
      slugs,
      page,
      limit: 10,
    });

    dispatch(
      queryFetchGhostPostSuccess({
        data: resp.data.authorPosts.concat(resp.data.otherPosts),
        meta: resp.data.authorMeta,
      })
    );
  } catch (error) {
    dispatch(queryFetchGhostPostError(error));
  }
};

export const queryAddUserToTribe = params => dispatch => {
  const { receiverId, senderId, action = '', config = {}, endorsement } = params;

  const id = new UUID(senderId);
  const updatedData = {
    receiverId,
    senderId,
    action,
    endorsement,
  };

  dispatch(addUsersToTribeRequest(receiverId));

  const fetchCurrentUserOptions = {
    updateHasListings: false,
    updateNotifications: false,
  };
  return onAddToTribe(updatedData)
    .then(() => {
      return Promise.all([
        dispatch(fetchCurrentUser(fetchCurrentUserOptions)),
        dispatch(showUser(id, config)),
        dispatch(fetchTribeUserListings(id, config)),
        dispatch(fetchEndorsedUsers(id, config)),
        dispatch(queryUserListings(id, config)),
        dispatch(queryUserReviews(id)),

        dispatch(addUsersToTribeSuccess()),
      ]);
    })
    .catch(err => {
      console.log('err', err);
    });
};

export const sendSuccessJoinToTribeEmail = params => async dispatch => {
  const { senderId, receiverId } = params;

  const data = {
    senderId: receiverId,
    receiverId: senderId,
    emailId: 100040,
    text: 'user is Now in Your Tribe',
    profileUrl: `${process.env.REACT_APP_MARKETPLACE_ROOT_URL}/u/:id`,
  };
  dispatch(querySendEmailPending());

  try {
    const response = await onSendEmail(data);
    dispatch(querySendEmailSuccess(`User was successfully joined to Tribe`));
    return response;
  } catch (error) {
    dispatch(querySendEmailError('Failed to send email!'));
    throw error;
  }
};

export const queryUserListings = (userId, config, ownProfileOnly = false) => (
  dispatch,
  getState,
  sdk
) => {
  dispatch(queryListingsRequest(userId));

  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  const queryParams = {
    include: ['author', 'images'],
    pub_listingType: 'session_price',
    'fields.image': [`variants.${variantPrefix}`, `variants.${variantPrefix}-2x`],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
  };

  const listingsPromise = ownProfileOnly
    ? sdk.ownListings.query({
        states: ['published'],
        ...queryParams,
      })
    : sdk.listings.query({
        author_id: userId,
        ...queryParams,
      });

  return listingsPromise
    .then(response => {
      const listings = response.data.data;
      const listingRefs = listings
        .filter(l => !l.attributes.deleted && l.attributes.state === 'published')
        .map(({ id, type }) => ({ id, type }));
      dispatch(addMarketplaceEntities(response));
      dispatch(queryListingsSuccess(listingRefs));
      return response;
    })
    .catch(e => dispatch(queryListingsError(storableError(e))));
};

export const queryUserReviews = userId => (dispatch, getState, sdk) => {
  sdk.reviews
    .query({
      subject_id: userId,
      state: 'public',
      include: ['author', 'author.profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    })
    .then(response => {
      const reviews = denormalisedResponseEntities(response);
      dispatch(queryReviewsSuccess(reviews));
    })
    .catch(e => dispatch(queryReviewsError(e)));
};

export const showUser = (userId, config) => (dispatch, getState, sdk) => {
  dispatch(showUserRequest(userId));
  return sdk.users
    .show({
      id: userId,
      include: ['profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    })
    .then(response => {
      const userFields = config?.user?.userFields;
      const sanitizeConfig = { userFields };
      dispatch(addMarketplaceEntities(response, sanitizeConfig));
      dispatch(showUserSuccess());
      return response;
    })
    .catch(e => {
      return dispatch(showUserError(storableError(e)));
    });
};

export const fetchTribeUserListings = (userId, config) => async (dispatch, getState, sdk) => {
  dispatch(queryTribeUserListingsRequest());

  try {
    const userData = await dispatch(showUser(userId, config));
    const currentUser = userData?.data?.data;

    const { attributes } = currentUser;
    const { profile } = attributes;
    const { publicData } = profile;
    const { endorsedUsersId = [] } = publicData;

    const aspectWidth = 1;
    const aspectHeight = 1;
    const variantPrefix = 'listing-card';

    const aspectRatio = aspectHeight / aspectWidth;

    const params = {
      pub_listingType: 'session_price',
      include: ['author', 'author.profileImage', 'images'],
      'fields.listing': [
        'title',
        'geolocation',
        'price',
        'deleted',
        'state',
        'publicData.listingType',
        'publicData.transactionProcessAlias',
        'publicData.unitType',
        'publicData.pickupEnabled',
        'publicData.shippingEnabled',
      ],
      'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
      'fields.image': [
        'variants.scaled-small',
        'variants.scaled-medium',
        `variants.${variantPrefix}`,
        `variants.${variantPrefix}-2x`,
      ],
      ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
      ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
      'limit.images': 1,
    };

    const endorsedUsersServicesResponses = await Promise.all(
      endorsedUsersId.map(id =>
        sdk.listings.query({
          authorId: id,
          ...params,
        })
      )
    );

    const endorsedUsersServices = endorsedUsersServicesResponses
      .map(res => denormalisedResponseEntities(res))
      .flat();

    dispatch(queryTribeUserListingsSuccess(endorsedUsersServices));
  } catch (error) {
    dispatch(queryTribeUserListingsError(error));
  }
};

// Fetch users which endorsed current user
export const fetchEndorsedUsers = (userId, config) => async (dispatch, getState, sdk) => {
  try {
    dispatch(showEndorsedUsersRequest());
    const userData = await dispatch(showUser(userId, config));
    const currentUserData = userData.data.data;
    const endorsedUsersId = currentUserData.attributes.profile.publicData.endorsedUsersId ?? [];

    const parameters = {
      include: ['effectivePermissionSet', 'profileImage', 'stripeAccount'],
      'fields.image': [
        'variants.square-small',
        'variants.square-small2x',
        'variants.square-xsmall',
        'variants.square-xsmall2x',
      ],
      'imageVariant.square-xsmall': sdkUtil.objectQueryString({
        w: 40,
        h: 40,
        fit: 'crop',
      }),
      'imageVariant.square-xsmall2x': sdkUtil.objectQueryString({
        w: 80,
        h: 80,
        fit: 'crop',
      }),
    };

    // TODO: fix potential falsy value inside endorsedUsersId
    const endorsedUsersResponses = await Promise.all(
      endorsedUsersId.filter(Boolean).map(id =>
        sdk.users.show({ id, ...parameters }).catch(e => {
          console.error(`Failed to fetch user ${id}:`, e);
          return null;
        })
      )
    );

    const endorsedUsers = endorsedUsersResponses
      .filter(Boolean)
      .flatMap(res => denormalisedResponseEntities(res));

    dispatch(showEndorsedUsersSuccess(endorsedUsers));
  } catch (error) {
    console.error('Error fetching endorsed users:', error);
    dispatch(showEndorsedUsersError(error));
  }
};

const isCurrentUser = (userId, cu) => userId?.uuid === cu?.id?.uuid;

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  const userId = new UUID(params.id);
  const isPreviewForCurrentUser = params.variant === PROFILE_PAGE_PENDING_APPROVAL_VARIANT;
  const currentUser = getState()?.user?.currentUser;
  const fetchCurrentUserOptions = {
    updateHasListings: false,
    updateNotifications: false,
  };

  dispatch(setInitialState());

  if (isPreviewForCurrentUser) {
    return dispatch(fetchCurrentUser(fetchCurrentUserOptions)).then(() => {
      if (isCurrentUser(userId, currentUser) && isUserAuthorized(currentUser)) {
        return Promise.all([
          dispatch(showUser(userId, config)),
          dispatch(queryUserListings(userId, config)),
          dispatch(queryUserReviews(userId)),
        ]);
      } else if (isCurrentUser(userId, currentUser)) {
        return dispatch(showUserRequest(userId));
      } else {
        return Promise.resolve({});
      }
    });
  }

  const isAuthorized = currentUser && isUserAuthorized(currentUser);
  const isPrivateMarketplace = config.accessControl.marketplace.private === true;
  const hasNoViewingRights = currentUser && !hasPermissionToViewData(currentUser);
  const canFetchData = !isPrivateMarketplace || (isPrivateMarketplace && isAuthorized);
  const canFetchOwnProfileOnly =
    isPrivateMarketplace &&
    isAuthorized &&
    hasNoViewingRights &&
    isCurrentUser(userId, currentUser);

  const userData = await dispatch(showUser(userId, config));
  const currentUserData = userData?.data?.data;
  const authorSlug = currentUserData?.attributes?.profile?.publicData?.authorSlug;
  const additionalGhostArticles =
    currentUserData?.attributes?.profile?.publicData?.additionalGhostArticles ?? [];
  const slugs = additionalGhostArticles.map(getSlugFromUrl);

  if (!canFetchData) {
    return Promise.resolve();
  } else if (canFetchOwnProfileOnly) {
    return Promise.all([
      dispatch(fetchCurrentUser(fetchCurrentUserOptions)),
      dispatch(queryUserListings(userId, config, canFetchOwnProfileOnly)),
      dispatch(showUserRequest(userId)),
    ]);
  }
  dispatch(fetchTribeUserListings(userId, config));
  dispatch(fetchEndorsedUsers(userId, config));
  dispatch(getPosts(authorSlug, slugs));
  return Promise.all([
    dispatch(fetchCurrentUser(fetchCurrentUserOptions)),
    dispatch(showUser(userId, config)),
    dispatch(queryUserListings(userId, config)),
    dispatch(queryUserReviews(userId)),
  ]);
};
